export const internationalTrackingUrls = {
  "356": "https://www.cargolux.com/track-and-trace/#numbers=",
  "994": "https://portal.airzetacargo.com/tracking/viewTraceAirWaybill.do",
  "180": "https://cargo.koreanair.com/ko/tracking",
  "988": "https://www.asianacargo.com/tracking/viewTraceAirWaybill.do",
};

export const customsTrackingUrl = "https://unipass.customs.go.kr/csp/index.do";
